import { Autocomplete, Box, Grid, Paper, TextField, Typography } from "@mui/material";
import RequiredLabel from "components/RequiredLabel";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const hasInsuranceOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export default function HealthInsurance() {
  const { control, watch } = useFormContext();
  const hasInsurance = watch("hasInsurance");
  const { t } = useTranslation();

  return (
    <Box>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mt: 1 }}>
        <Box
          backgroundColor="divider"
          sx={{ p: 2, borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
        >
          <Typography variant="h6">{t("Medical Insurance Information")}</Typography>
        </Box>

        <Grid container spacing={2} pt={1}>
          <Grid item xs={12} md={6}>
            <Controller
              name="hasInsurance"
              control={control}
              render={({ field, fieldState }) => (
                <Autocomplete
                  options={hasInsuranceOptions}
                  getOptionLabel={(option) => option.label}
                  value={
                    hasInsuranceOptions.find((opt) => opt.value === field.value) ||
                    null
                  }
                  onChange={(_, newValue) =>
                    field.onChange(newValue ? newValue.value : "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<RequiredLabel>{t("Does your child have health insurance?")}</RequiredLabel>}
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      fullWidth
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Controller
              name="insuranceProvider"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={ hasInsurance === "yes" ? <RequiredLabel>{t("Insurance Provider")}</RequiredLabel> : t("Insurance Provider")}
                  fullWidth
                  disabled={hasInsurance !== "yes"}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
